<template>
  <div class="row pb-3">
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label">Email addresses</label>
        <InputTag 
          placeholder="Enter email"
          label="name" 
          v-model="model.emails"
          add-tag-on-blur
          validate="email"
          class="vue-input-tag-custom"
        ></InputTag>
        <small class="text-muted pt-1">Enter up to 10 email addresses, separated by a comma.</small>
      </div>
    </div>
  </div>
</template>

<script>
import InputTag from 'vue-input-tag'
import FormMixin from '@mixins/form'

import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    InputTag,
  },
  data() {
    return {
      model: {
        emails: [],
        access_type: 'candidate'
      },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    type() {
      let parameters = this.parameters || {}
      return parameters.type
    }
  },
  async created () {
  },
  mixins:[ FormMixin ],
  validations: {
		model:{
			emails: {
				required
      }
		}
	}
}
</script>